import { useEffect } from "react";
import { useLocation } from "wouter";

function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // remove smooth if you want instant jump
    });
  }, [location]);

  return null;
}

export default ScrollToTop;
